import { render, staticRenderFns } from "./OneDisplay.vue?vue&type=template&id=5068d009&scoped=true&"
import script from "./OneDisplay.vue?vue&type=script&lang=js&"
export * from "./OneDisplay.vue?vue&type=script&lang=js&"
import style0 from "./OneDisplay.vue?vue&type=style&index=0&id=5068d009&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5068d009",
  null
  
)

export default component.exports